export default __webpack_public_path__ + "static/media/teal@3x.32a6261f.png";